import React from "react";
import s from './Button.module.scss'

export const Button = ({onClick = () => {}, type, value="", disabled }) => {
    return <button onClick={onClick} type={type} className={s.formButton} disabled={disabled}>{value}</button>
}